import { MaximumBudget } from "@justhome/common/api/core";
import { BudgetCheckFormValues, YesNo } from "./types";

const formatYearMonthDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.getMonth() + 1;
  return `${date.getFullYear()}-01-${month >= 10 ? month : `0${month}`}`;
};

const mapFormToMaximumBudget = (
  form: BudgetCheckFormValues,
  leadId?: string,
  partnerId?: string,
): MaximumBudget => {
  const monthlyNetIncome: number = form.yearlyNetIncome
    ? form.yearlyNetIncome / 12
    : form.monthlyNetIncome || 0;

  const employmentStart = form.employmentStart
    ? formatYearMonthDate(form.employmentStart)
    : "2000-01-01";

  const result: MaximumBudget = {
    federalState: form.federalState,
    employmentType: form.employmentType,
    employmentStart,
    employmentTemporary: false,
    equity: form.equity,
    existingDebt: form.existingDebt || 0,
    monthlyNetIncome,
    leadId,
    partnerId,
  };

  if (form.wantsToSellAProperty) {
    result.wantsToSellAProperty = form.wantsToSellAProperty === YesNo.yes;
  }

  if (form.hasSpecificProperty) {
    result.hasSpecificProperty = form.hasSpecificProperty === YesNo.yes;
  }

  if (form.searchProfile) {
    result.searchProfile = {
      ...form.searchProfile,
      propertyType:
        form.searchProfile?.propertyType === "OTHER"
          ? undefined
          : form.searchProfile?.propertyType,
      minRooms: Number(form.searchProfile.rooms?.[0]),
      maxRooms: Number(form.searchProfile.rooms?.[1]),
      minSquaremeter: Number(form.searchProfile.squaremeter?.[0]),
      maxSquaremeter: Number(form.searchProfile.squaremeter?.[1]),
    };
  }

  return result;
};

export default mapFormToMaximumBudget;
